// import QrReader from "react-qr-reader";
import { Scanner } from "@yudiel/react-qr-scanner";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ModalComponent from "..";
import { ModalCompProps } from "../../../utils/types";

export const QRScanner = ({
  open,
  handleClose,
  onSuccess,
}: ModalCompProps & { onSuccess: (result: string) => void }) => {
  const [isCameraPermissionGranted, setIsCameraPermissionGranted] =
    useState(false);

  useEffect(() => {
    navigator.permissions
      .query({ name: "camera" })
      .then((result) => {
        if (result.state === "granted") {
          setIsCameraPermissionGranted(true);
        } else if (result.state === "prompt" && open) {
          setIsCameraPermissionGranted(false);
          handleClose();
          navigator.mediaDevices.getUserMedia({ video: true });
        } else if (result.state === "denied" && open) {
          setIsCameraPermissionGranted(false);
          handleClose();
          toast.error("Camera permission denied");
        }
      })
      .catch((error) => {
        console.error("Permission check failed:", error);
      });
    // eslint-disable-next-line
  }, [open]);

  try {
    return isCameraPermissionGranted ? (
      <ModalComponent
        open={open}
        handleClose={() => {
          handleClose();
        }}
        dialogClassName="!max-h-[100%] items-center justify-center flex w-full !overflow-scroll"
        showBackIcon={false}
        className="!bg-transparent !p-0 md:!max-w-[500px]"
        closeOnOverlayClick
        showCloseIcon={true}
        showHeader={true}
        closeButtonClassName="!bg-transparent"
      >
        <Scanner
          onScan={(result) => {
            if (!!result) {
              onSuccess(result[0].rawValue);
            }
          }}
          onError={(error) => {
            if (!!error) {
              console.log(error);
            }
          }}
          sound={false}
          constraints={{
            facingMode: "environment",
          }}
          scanDelay={1000}
          styles={{
            video: {},
            container: {
              border: "1px solid transparent",
              borderRadius: "16px",
              overflow: "hidden",
              maxWidth: "500px",
              maxHeight: "500px",
            },
          }}
        >
          <div>hello</div>
        </Scanner>
        {/* <QrReader
          facingMode="environment"
          onScan={(result) => {
            if (!!result) {
              onSuccess(result);
            }
          }}
          onError={(error) => {
            if (!!error) {
              console.log(error);
            }
          }}
          delay={1000}
          className="size-[350px] border"
        /> */}
      </ModalComponent>
    ) : undefined;
  } catch (error) {
    console.error("An error occurred in QRScanner:", error);
    return null;
  }
};
